import React from 'react';
import Icon from '../../../components/AppIcon';

const BenefitsSection = () => {
  const benefits = [
    {
      id: 1,
      icon: "DollarSign",
      title: "Transparent Pricing",
      description: "No hidden markups or surprise deductions. You know exactly what you\'ll earn on every job with our transparent 20% fee model.",
      highlight: "Fair & Predictable"
    },
    {
      id: 2,
      icon: "Calendar",
      title: "Steady Work Flow",
      description: "Access to a consistent pipeline of pre-qualified customers. Our platform matches you with homeowners ready to move forward.",
      highlight: "15-25 Jobs/Month"
    },
    {
      id: 3,
      icon: "GraduationCap",
      title: "Professional Growth",
      description: "Continuous training, certification programs, and access to the latest roofing technologies and techniques.",
      highlight: "Skill Development"
    },
    {
      id: 4,
      icon: "Shield",
      title: "Insurance & Protection",
      description: "Comprehensive liability coverage and warranty support. We\'ve got your back on every project you complete.",
      highlight: "Full Coverage"
    },
    {
      id: 5,
      icon: "Smartphone",
      title: "Digital Tools",
      description: "Advanced project management app, automated measurements, customer communication tools, and real-time job tracking.",
      highlight: "Tech-Enabled"
    },
    {
      id: 6,
      icon: "Users",
      title: "Community Support",
      description: "Join a network of top-tier contractors. Share knowledge, get support, and grow together in our professional community.",
      highlight: "500+ Partners"
    }
  ];

  return (
    <section className="py-16 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center space-y-6 mb-16">
          <div className="inline-flex items-center px-4 py-2 bg-primary/10 rounded-full">
            <Icon name="Star" size={16} className="text-primary mr-2" />
            <span className="text-sm font-medium text-primary">Partner Benefits</span>
          </div>
          
          <h2 className="text-3xl lg:text-4xl font-jakarta font-bold text-text-primary">
            Why Top Contractors Choose OpenbooQ
          </h2>
          
          <p className="text-lg text-text-secondary max-w-3xl mx-auto">
            We're not just another lead generation service. We're your business growth partner, 
            providing everything you need to succeed in the modern roofing industry.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits?.map((benefit) => (
            <div 
              key={benefit?.id}
              className="group relative bg-white border border-border rounded-xl p-8 hover:shadow-trust transition-all duration-300 hover:-translate-y-1"
            >
              <div className="space-y-6">
                <div className="flex items-center justify-between">
                  <div className="w-12 h-12 bg-gradient-to-br from-primary to-secondary rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                    <Icon name={benefit?.icon} size={24} className="text-white" />
                  </div>
                  <div className="px-3 py-1 bg-primary/10 rounded-full">
                    <span className="text-xs font-medium text-primary">{benefit?.highlight}</span>
                  </div>
                </div>
                
                <div className="space-y-3">
                  <h3 className="text-xl font-jakarta font-semibold text-text-primary group-hover:text-primary transition-colors duration-300">
                    {benefit?.title}
                  </h3>
                  <p className="text-text-secondary leading-relaxed">
                    {benefit?.description}
                  </p>
                </div>
              </div>
              
              {/* Hover effect */}
              <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-secondary/5 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 -z-10"></div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-16">
          <div className="inline-flex items-center space-x-2 text-sm text-text-secondary mb-4">
            <Icon name="CheckCircle" size={16} className="text-success" />
            <span>No upfront costs • No long-term contracts • Start earning immediately</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;